import { ContentBlock } from '@careguide/theme'
import { Heading } from '@careguide/typography'
import { Stack } from '@careguide/stack'

import Button from 'components/generic/Button/Button'

const ListingUpgradeCTA = ({ name }: { name: string }) => (
  <ContentBlock as='span' bg='gray.1' borderRadius='small' p='4' pt='5'>
    <Stack gap='5'>
      <Heading as='h2' align='center'>
        Want to connect with {name}?
      </Heading>
      <Button href='/upgrade'>Upgrade</Button>
    </Stack>
  </ContentBlock>
)

export default ListingUpgradeCTA
